import { useEffect, useState } from "react";
import { _DOCFileRecord, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { Alert } from "../../../theme/Component/Alert";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { mapFileRecordToFolderItem } from "./DocumentFileManager.types";
import { DocumentFileManagerContent } from "./components/DocumentFileManagerContent";
import "./DocumentFileManager.css";
import { SelectTrdsID } from "../../../admin/configuracion/TrdID/SelectTrdsID";
import { DocumentRecordFormValue } from "./components/DocumentRecordsView";





interface EditorExpedienteProps {
    _ClassForName: string;
    _IDClass: number;
    recordData?: Partial<DocumentRecordFormValue>;
}

const getInitialRecordForm = (recordData?: Partial<DocumentRecordFormValue>): DocumentRecordFormValue => ({
    name: recordData?.name ?? "",
    description: recordData?.description ?? "",
    idln: recordData?.idln ?? null,
});

export const EditorExpedientDocumentFile = ({ _ClassForName, _IDClass, recordData }: EditorExpedienteProps) => {

    const { instance, setLista, lista } = useDataBean(_DOCFileRecord);
    const paginadorRecord = usePaginator();
    const [loading, setLoading] = useState(true);
    const [recordForm, setRecordForm] = useState<DocumentRecordFormValue>(() => getInitialRecordForm(recordData));

    useEffect(() => {
        setRecordForm(getInitialRecordForm(recordData));
    }, [recordData?.name, recordData?.description, recordData?.idln]);

    useEffect(() => {
        getLista();
    }, [paginadorRecord.page, _ClassForName, _IDClass]);

    const getLista = () => {
        setLoading(true);
        instance.getDOCFileRecordRender(null, null, { ClassForName: _ClassForName, IDClass: _IDClass }).then(
            (resp) => {
                paginadorRecord.setPages(resp.NumberOfPages ?? 1);
                paginadorRecord.setRecords((resp.NumberOfPages ?? 1) * 15);
                paginadorRecord.setRegiPerPage(15);
                if (resp.List.length === 0) {
                    toast.info("No se encontro un expediente Asociado");
                } else if (resp.List.length > 1) {
                    toast.warning("Se encontraron mas de 1 un expediente asociado");
                }
                setLista(resp.List ?? []);
            }
        ).catch(err => {
            toast.error(err);
            setLista([]);
        }).finally(() => setLoading(false));
    };

    const submitCreateRecord = () => {
        if (!recordForm.name.trim()) {
            toast.error("Debe ingresar el nombre");
            return;
        }

        if (!recordForm.idln) {
            toast.error("Debe seleccionar un TRD");
            return;
        }

        instance.createDOCFileRecord(
            _single.getAccountID(),
            recordForm.name.trim(),
            recordForm.description.trim(),
            recordForm.idln,
            _ClassForName,
            _IDClass
        ).then(() => {
            setRecordForm({ name: "", description: "", idln: null });
            getLista();
        }).catch(err => toast.error(err));
    };

    if (loading) return null;

    if (lista.length > 1) {
        return (
            <Alert clase="danger">
                Se tiene mas de un expediente creado para este registro.
            </Alert>
        );
    }

    if (lista.length === 1) {
        const folder = mapFileRecordToFolderItem(lista[0]);

        return (
            <div className="document-file-manager document-file-manager--detail">
                <main className="document-file-manager__content">
                    <DocumentFileManagerContent
                        fileRecordId={folder.id}
                        fileRecordName={folder.name}
                    />
                </main>
            </div>
        );
    }

    return (
        <section className="document-records-view">
            <div className="document-records-view__header">
                <div>
                    <span className="document-records-view__eyebrow">Repositorio</span>
                    <h1 className="document-records-view__title">Crear expediente</h1>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <label>Nombre <span className="text-danger">*</span></label>
                    <input
                        className="form-control"
                        type="text"
                        value={recordForm.name}
                        onChange={(event) => setRecordForm({ ...recordForm, name: event.target.value })}
                    />
                </div>
                <div className="col-md-6">
                    <SelectTrdsID
                        edit={false}
                        trdIDLn={recordForm.idln ?? undefined}
                        onChange={(trd: any) => setRecordForm({ ...recordForm, idln: trd.IDLn })}
                    />
                </div>
                <div className="col-md-12">
                    <label>Descripcion</label>
                    <textarea
                        className="form-control"
                        value={recordForm.description}
                        onChange={(event) => setRecordForm({ ...recordForm, description: event.target.value })}
                    />
                </div>
            </div>

            <div className="mt-3">
                <BasicButton icon="ri-add-line" eventClick={submitCreateRecord} clase="primary" timeStopClickSeg={250}>
                    Crear expediente
                </BasicButton>
            </div>
        </section>
    );
};
